<div class="videoContainer">
	<div class="threeeByThree">
		<div class="topLeft aspectRatio169">
			<sim-screen-container [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" [screenIndex]="0" />
		</div>
		<div class="topCenter aspectRatio169">
			<sim-screen-container [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" [screenIndex]="1" />
		</div>
		<div class="topRight aspectRatio169">
			<sim-screen-container [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" [screenIndex]="2" />
		</div>
		<div class="centerLeft aspectRatio169">
			<sim-screen-container [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" [screenIndex]="3" />
		</div>
		<div class="centerCenter aspectRatio169">
			<sim-screen-container [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" [screenIndex]="4" />
		</div>
		<div class="centerRight aspectRatio169">
			<sim-screen-container [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" [screenIndex]="5" />
		</div>
		<div class="bottomLeft aspectRatio169">
			<sim-screen-container [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" [screenIndex]="6" />
		</div>
		<div class="bottomCenter aspectRatio169">
			<sim-screen-container [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" [screenIndex]="7" />
		</div>
		<div class="bottomRight aspectRatio169">
			<sim-screen-container [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" [screenIndex]="8" />
		</div>
	</div>
</div>
